import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { SkeletonHeadline, SkeletonBody } from '@xing-com/skeleton';
import { scale180, scale210, spaceM, spaceXS } from '@xing-com/tokens';

const StyledSkeletonHeadline = styled(SkeletonHeadline)`
  margin-bottom: ${spaceM};
`;

const StyledSkeletonBodyCopy = styled(SkeletonBody)`
  margin-bottom: ${spaceXS};
`;

const SkeletonWrapper = styled.div`
  margin-bottom: ${scale210};

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${scale180};
  }
`;

export const Styled = {
  SkeletonHeadline: StyledSkeletonHeadline,
  SkeletonBodyCopy: StyledSkeletonBodyCopy,
  SkeletonWrapper,
};
